module.exports = __webpack_public_path__ + "assets/6c9b6d0fac69ea0ea9943f06d3e91eeb.mp3";